import { useRequiredContext } from "@redotech/react-util/context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { memo } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { ConversionSuiteStatusesContext } from "../../redo-suite/conversion-cloud";

/**
 * Route-level guard for direct-URL access to gated Conversion Cloud features
 * (CRO-1387). Renders the matching child route only when the team has access;
 * intent-only teams get redirected to the Conversion dashboard, where the
 * upsell pitch lives.
 *
 * Wrap the parent route of any gated path:
 *
 *   { path: "ab-tests", element: <ConversionFeatureGate />, children: [...] }
 */
export const ConversionFeatureGate = memo(function ConversionFeatureGate() {
  const { accessLevel } = useRequiredContext(ConversionSuiteStatusesContext);
  const routes = useRequiredContext(MerchantRoutesContext);

  if (accessLevel === "intent-only" || accessLevel === "intent-only-small") {
    return <Navigate replace to={routes.getConversionSubRoute("dashboard")} />;
  }

  return <Outlet />;
});
